export default {
  localhost: "http://localhost:5000",
  stage: "https://api-backoffice-stg.cpfltotal.com.br",
  production: "https://api-backoffice.cpfltotal.com.br",
};
